var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {
    staticClass: "research-method-wrapper",
    domProps: { innerHTML: _vm._s(this.researchMethod[0]["body"]) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }